<template>
  <div>
    <HeaderControls :myWeek='false' :parentDeliverableId="parentDeliverableId" @filterUpdated='filterUpdate'
      @collapseToggleUpdated='collapseToggleUpdate' @showEditDeliverableModal="showEditDeliverableModal"
      :namespace="namespace" :tabTitle="tabTitle" ref="refHeaderControls" :showLogo="showLogo" />
    <div class="deliverable-main container-fluid">


      <b-modal size="lg" no-close-on-backdrop hide-footer id="editSocialModal" title="Edit Related Social Deliverable"
        class="modal-edit-social-deliverable" @show="editSocialModalShown" @shown="afterEditSocialModalShown"
        @hide="editSocialModalHidden" no-close-on-esc>
        <EditSocialModal :allContacts="allContacts" :tabIndex="tabIndex" ref="refEditRelatedSocialModal"
          :namespace="namespace" modalId="editSocialModal" />
      </b-modal>

      <SocialScheduleCalendar v-if="systemSettingsReady" :myWeek="false" :expandAll="expandAll"
        @collapseToggleUpdated='collapseToggleUpdate' :namespace="namespace" :parentDeliverableId="parentDeliverableId"
        ref="refSocialScheduleCalendar" @showEditDeliverableModal="showEditDeliverableModal" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import HeaderControls from "../common/HeaderControlsRelatedDeliverablesSocialCalendar";
import SocialScheduleCalendar from "./SocialScheduleCalendar";
import EditSocialModal from "./EditSocialModal";


export default {
  data() {
    return {
      expandAll: !this.isMobile(),
      systemSettingsReady: false,
      tabIndex: 0,
      selectedDeliverable: false,
    }
  },
  props: {
    parentDeliverableId: Number,
    namespace: String,
    tabTitle: String,
    showLogo: Boolean,
    openedDirectlyWithModal: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapState({
      state(state) {
        return state[this.namespace]
      },
      allCustomFields(state, getters) {
        return getters[this.namespace + 'allCustomFields']
      },
      allUsers(state, getters) {
        return getters['allUsers']
      },
      systemSettings(state, getters) {
        return getters['systemSettings']
      },
      allContacts(state, getters) {
        return getters[this.namespace + 'allContacts']
      },
      deliverableDetail(state, getters) {
        return getters[this.namespace + 'deliverableDetail']
      },

    }),
    forceUpdateCounter() {
      return this.deliverables.forceUpdateCounter;
    },
    statuses() {
      let statusField = _.find(this.allCustomFields, { field_key: "status" });
      if (typeof statusField != "undefined") {
        let valueSet = [],
          data = JSON.parse(statusField.value_set);
        Object.keys(data).forEach(function (item) {
          valueSet.push(data[item]);
        });
        return valueSet;
      }
    }
  },
  components: {
    SocialScheduleCalendar,
    HeaderControls,
    EditSocialModal
  },
  methods: {
    ...mapActions({
      fetchSystemSettings(dispatch, payload) {
        return dispatch('fetchSystemSettings', payload)
      },
    }),
    filterUpdate(filterQuery) {
      this.filterQuery = filterQuery
    },
    updateProjectUrlForRelatedDeliverable(deliverableId) {
      if (!deliverableId) { 
        return;
      }
      const currentPath = window.location.pathname;
      const isProjectOrMyProjects = currentPath.includes('/my-projects/') || currentPath.includes('/project/');
      const isSocialMediaScheduleDetail = /\/social-media-schedule\/\d+/.test(currentPath);
      
      if (this.parentDeliverableId || isSocialMediaScheduleDetail) {
        const query = new URLSearchParams(window.location.search || '');
        const alreadyHasOpenDeliverable = query.has('openDeliverable');
        query.set('openDeliverable', deliverableId);
        query.set('openChildTask', '1');
        const url = `${currentPath}${query.toString() ? `?${query.toString()}` : ''}${window.location.hash || ''}`;
        if (!alreadyHasOpenDeliverable) {
          history.pushState(history.state || {}, null, url);
        } else {
          history.replaceState(history.state || {}, null, url);
        }
      } else if (isProjectOrMyProjects) {
        const query = new URLSearchParams(window.location.search || '');
        query.set('openDeliverable', deliverableId);
        query.set('openChildTask', '1');
        const url = `${window.location.pathname}${query.toString() ? `?${query.toString()}` : ''}${window.location.hash || ''}`;
        history.replaceState(history.state || {}, null, url);
      }
    },

    editSocialModalShown() {
      document.body.classList.add("social-modal-open");
      $("#content").scrollTop(this.windowScrollTop);
    },
    afterEditSocialModalShown() {
      document.body.classList.add("social-modal-shown");
    },
    editSocialModalHidden() {
      if (this._closedByPopstate) {
        this._closedByPopstate = false;
        this.windowScrollTop = $("#content").scrollTop();
        document.body.classList.remove("social-modal-open");
        document.body.classList.remove("social-modal-shown");
        $(window).scrollTop(this.windowScrollTop);
        this.$store.commit(this.namespace + 'setDeliverable', this.deliverableDetail);
        this.$store.commit(this.namespace + 'setCalendarDeliverable', this.deliverableDetail);
        this.selectedDeliverable = false;
        return;
      }
      
      this.windowScrollTop = $("#content").scrollTop();
      document.body.classList.remove("social-modal-open");
      document.body.classList.remove("social-modal-shown");
      $(window).scrollTop(this.windowScrollTop);
      this.$store.commit(this.namespace + 'setDeliverable', this.deliverableDetail);
      this.$store.commit(this.namespace + 'setCalendarDeliverable', this.deliverableDetail);
      this.selectedDeliverable = false;
      const query = new URLSearchParams(window.location.search || '');
      const hasOpenDeliverable = query.has('openDeliverable');
      const currentPath = window.location.pathname;
      const isSocialMediaScheduleDetail = /\/social-media-schedule\/\d+/.test(currentPath);
      if (hasOpenDeliverable) {
        query.delete('openDeliverable');
        query.delete('openChildTask');
        const newUrl = `${window.location.pathname}${query.toString() ? `?${query.toString()}` : ''}${window.location.hash || ''}`;
        history.replaceState(history.state || {}, null, newUrl);
      } else if (isSocialMediaScheduleDetail) {
        if (this.openedDirectlyWithModal) {
          this.$emit('resetOpenedDirectly');
          this.$router.push({ name: 'socialMediaSchedule' });
        } else {
          this.$router.back();
        }
      }
    },

    showEditDeliverableModal(deliverable, tab, skipUrlUpdate = false) {
      let that = this;
      this.windowScrollTop = $(window).scrollTop();
      let deliverableId = null;
      if (typeof deliverable === "object") {
        deliverableId = deliverable.id;
        this.selectedDeliverable = deliverable.id;
        if (deliverable.social_series.length && !deliverable.manually_updated_at) {
          deliverableId = this.getSeriesMasterByDeliverable(deliverable);
        }
      } else {
        deliverableId = deliverable;
        this.selectedDeliverable = deliverableId;
      }
      if (tab === null || tab === undefined) {
        tab = 2;
      }
      this.tabIndex = tab;

      this.$store.dispatch(this.namespace + "getDeliverableDetail", { deliverableId })
        .then(() => {
          if (this.$refs.refEditRelatedSocialModal) {
          } else {
            if (!skipUrlUpdate) {
              this.updateProjectUrlForRelatedDeliverable(deliverableId);
            }
            that.tabIndex = tab;
            that.$bvModal.show("editSocialModal", {
              backdrop: 'static',
              keyboard: true,
            });
          }
        });

      this.$root.$emit('bv::modal::disable-pointer-events');
    },

    collapseToggleUpdate(expandAll) {
      this.expandAll = expandAll
    },
    checkSystemSettingsReady() {
      if (this.systemSettings.publish_statuses) {
        this.systemSettingsReady = true;
      } else {
        this.systemSettingsReady = false;
      }
    },
    getSeriesMasterByDeliverable(deliverable) {
    	if (typeof deliverable.social_series_deliverables != "undefined") {
	      let series = deliverable.social_series_deliverables;
	      if (series.length) {
	        let master = series.find(x => x.is_master === 1);
	        if (master) {
	          return master.id;
	        }
	      }
	    }
      return false;
    },

  },
  mounted() {
    document.body.classList.add("social-media");
    this.handlePopstate = (event) => {
      const query = new URLSearchParams(window.location.search || '');
      const hasOpenDeliverable = query.has('openDeliverable');
      if (!hasOpenDeliverable) {
        this._closedByPopstate = true;
        this.$bvModal.hide("editSocialModal");
      }
    };
    window.addEventListener('popstate', this.handlePopstate);
  },
  created() {
    this.fetchSystemSettings();
    this.checkSystemSettingsReady();
  },
  beforeDestroy() {
    if (this.handlePopstate) {
      window.removeEventListener('popstate', this.handlePopstate);
    }
  },
  watch: {
    systemSettings(to, from) {
      this.checkSystemSettingsReady();
    },
  }
}
</script>
